"use client";

import Link from "next/link";
import CookieConsent from "react-cookie-consent";

/**
 * Pixar Labs cookie consent — design-styled wrapper around react-cookie-consent.
 * `disableStyles` stops the library injecting inline CSS; the whole banner is
 * styled with Tailwind. The library renders the text (content) and the buttons
 * (buttonWrapper) as siblings inside the container, so the container itself is
 * the card and lays them out in a row.
 */
const CookieConsentBar = () => (
  <CookieConsent
    location="bottom"
    cookieName="pixarlabs-cookie-accept"
    expires={150}
    disableStyles
    enableDeclineButton
    buttonText="Accept"
    declineButtonText="Decline"
    ariaAcceptLabel="Accept cookies"
    ariaDeclineLabel="Decline cookies"
    containerClasses="jlt-fixed jlt-bottom-5 jlt-left-1/2 jlt-z-[300] jlt-w-[min(1080px,calc(100%-40px))] -jlt-translate-x-1/2 jlt-flex jlt-flex-col jlt-items-start jlt-gap-4 jlt-rounded-3xl jlt-border jlt-border-pl-line jlt-bg-white/[.94] jlt-p-[clamp(18px,3vw,26px)] jlt-shadow-pl-lg jlt-backdrop-blur-[18px] md:jlt-flex-row md:jlt-items-center md:jlt-justify-between md:jlt-gap-6"
    contentClasses="jlt-flex-1"
    buttonWrapperClasses="jlt-flex jlt-flex-shrink-0 jlt-flex-wrap jlt-items-center jlt-gap-2"
    buttonClasses="jlt-inline-flex jlt-items-center jlt-justify-center jlt-rounded-full jlt-bg-pl-blue jlt-px-[22px] jlt-py-[10px] jlt-text-[14px] jlt-font-semibold jlt-text-white jlt-shadow-[0_10px_26px_-10px_rgba(42,76,255,.55)] jlt-transition-transform jlt-duration-200 jlt-ease-spring hover:-jlt-translate-y-[2px]"
    declineButtonClasses="jlt-inline-flex jlt-items-center jlt-justify-center jlt-rounded-full jlt-border-[1.5px] jlt-border-pl-line2 jlt-bg-white jlt-px-[22px] jlt-py-[10px] jlt-text-[14px] jlt-font-semibold jlt-text-pl-ink jlt-transition-colors jlt-duration-200 hover:jlt-border-pl-ink"
  >
    <p className="jlt-m-0 jlt-max-w-[640px] jlt-text-[14px] jlt-leading-[1.6] jlt-text-pl-ink2">
      We use cookies to keep you signed in, run checkout, and understand how the site is used. You
      can accept all cookies or decline the optional ones. See our{" "}
      <Link href="/cookie-policy" className="jlt-font-semibold jlt-text-pl-blue jlt-underline">
        Cookie Policy
      </Link>{" "}
      and{" "}
      <Link href="/privacy-policy" className="jlt-font-semibold jlt-text-pl-blue jlt-underline">
        Privacy Policy
      </Link>
      .
    </p>
  </CookieConsent>
);

export default CookieConsentBar;
